import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Returns() {
  const email = siteConfig.contact?.email;
  const returnWindow = siteConfig.returns?.windowDays || 30;

  useEffect(() => {
    document.title = `Returns — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="policy-page policy-page--returns" id="main-content">
      <header className="policy-hero">
        <p className="policy-eyebrow">Returns + exchanges</p>
        <h1>Let’s make it right.</h1>
        <p>
          We hope every {siteConfig.brandName} package feels like happy mail.
          If something is not right, here is how we can help.
        </p>
      </header>

      <div className="policy-highlights" aria-label="Return policy summary">
        <article><strong>{returnWindow} days</strong><span>to request an eligible return</span></article>
        <article><strong>Unused</strong><span>and in original packaging</span></article>
        <article><strong>5–10 days</strong><span>for approved refunds to post</span></article>
      </div>

      <div className="policy-layout">
        <aside className="policy-nav" aria-label="Returns policy sections">
          <p>On this page</p>
          <a href="#returns-eligible">What can be returned</a>
          <a href="#returns-start">Start a return</a>
          <a href="#returns-refund">Refunds</a>
          <a href="#returns-damage">Damaged orders</a>
          <a href="#returns-gifts">Gifts and exchanges</a>
        </aside>

        <article className="policy-content">
          <section className="policy-lead">
            <h2>Return window</h2>
            <p>
              Contact us within {returnWindow} days of delivery. Items must be unused,
              unmarked and in their original protective packaging. Please wait
              for return instructions before mailing anything back.
            </p>
          </section>

          <section id="returns-eligible">
            <h2>Eligible and non-returnable items</h2>
            <p>Most unused, regularly priced items may be returned. We cannot accept:</p>
            <ul>
              <li>Personalized, custom-made or handwritten products.</li>
              <li>Digital downloads, gift cards or items marked final sale.</li>
              <li>Opened stationery sets, used products or items damaged after delivery.</li>
              <li>Returns sent without authorization or outside the return window.</li>
            </ul>
            <p>Your statutory consumer rights are not affected.</p>
          </section>

          <section id="returns-start">
            <h2>How to start a return</h2>
            <ol className="policy-steps">
              <li><span>1</span><div><h3>Send us a note</h3><p>Use the <Link to="/contact">contact form</Link> with your order number and the item you would like to return.</p></div></li>
              <li><span>2</span><div><h3>Wait for approval</h3><p>We will confirm eligibility and send the return address and packing instructions.</p></div></li>
              <li><span>3</span><div><h3>Pack it safely</h3><p>Use the original packaging where possible and choose a trackable postal service.</p></div></li>
            </ol>
            <p>
              Unless an item arrived damaged or incorrect, return postage is
              the customer’s responsibility. Original delivery charges are
              non-refundable where allowed by law.
            </p>
          </section>

          <section id="returns-refund">
            <h2>Refunds</h2>
            <p>
              We inspect returns after arrival and email the outcome. Approved
              refunds go to the original payment method, usually within 5–10
              business days after processing. Your bank may need additional time.
            </p>
          </section>

          <section id="returns-damage">
            <h2>Damaged, incorrect or missing items</h2>
            <p>
              Contact us within 7 days of delivery with your order number and
              clear photos of the product and packaging. Keep all packaging
              until we reply. We will arrange an appropriate replacement or refund.
            </p>
          </section>

          <section id="returns-gifts">
            <h2>Gifts and exchanges</h2>
            <p>
              We do not currently process direct exchanges. Return the eligible
              item, then place a new order for the piece you prefer. Gift returns
              are normally issued as shop credit when proof of purchase is available.
            </p>
          </section>

          <section className="policy-contact">
            <p className="policy-eyebrow">Need a hand?</p>
            <h2>We will help untangle it.</h2>
            <p>
              Visit our <Link to="/contact">contact page</Link>
              {email && <> or email <a href={`mailto:${email}`}>{email}</a></>}.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Returns;
